import { useCallback, useEffect, useState } from "react";

/**
 * Use this hook recipe whenever a toggler is needed
 * @param {boolean} initialState setInitialValue
 * @returns Array
 */
export const useToggle = (initialState = false) => {

  const [state, setState] = useState(initialState);

  // Define and memorize toggler function in case we pass down the comopnent,
  // This function change the boolean value to it's opposite value
  const toggle = useCallback(() => setState(state => !state), []);

  return [state, toggle]
}



export const useContainerDimensions = myRef => {
  const getDimensions = () => ({
    width: myRef.current.offsetWidth,
    height: myRef.current.offsetHeight
  })

  const [dimensions, setDimensions] = useState({ width: 0, height: 0 })

  useEffect(() => {
    const handleResize = () => {
      setDimensions(getDimensions())
    }

    if (myRef.current) {
      setDimensions(getDimensions())
    }

    window.addEventListener("resize", handleResize)

    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [myRef])

  return dimensions;
};
export { default as useDetectClickOutside } from './useDetectClickOutside';


export const useDocumentVisibility = () => {
  const [inFocus, setInFocus] = useState(true)

  useEffect(() => {
    const checkVisibility = () => {
      if (document.visibilityState === "visible") {
        setInFocus(true);
      }
      else {
        setInFocus(false);
      }
    }
    document.addEventListener("visibilitychange", checkVisibility, false);
    return () => document.removeEventListener("visibilitychange", checkVisibility, false)
  }, [])
  return [inFocus];
}


export function useMobileView() {

  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {

    function checkMobileView() {
      if (window.matchMedia('only screen and (max-width:991.98px)').matches) {
        setIsMobileView(true)
      }
      else {
        setIsMobileView(false)
      }
    }
    checkMobileView()
    window.addEventListener("resize", checkMobileView, false)
    return () => {
      window.removeEventListener("resize", checkMobileView, false)
    }
  }, [])


  return isMobileView
}
